import { Routes, Route} from 'react-router-dom';
import './App.css';
import Container from './Components/Container';
import ContactContainer from './Components/ContactContainer';


function App() {
  return (
    <>
       <Routes>
         <Route path='/' element={<Container/>} />
         <Route path='/contact' element={<ContactContainer/>} />
        </Routes>
    </>
  );
}

export default App;
